export default {
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    showExplanation() {
      this.isActive = !this.isActive
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    }
  }
}
